import React, { useState } from 'react'
import { Dialog } from '@e3dc-react/shell/Elements/Dialog'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { AppLang } from '@e3dc-react/shell/State/App/AppModel'

import { changeAppLanguage, getCurrentLanguage } from 'src/Libs/languages/functions/default'
import LanguageSelector from './LanguageSelector'
import useUserLanguage from 'src/Libs/user/hooks/use-user-language'

export interface LanguageModalProps {
  onClose: () => void
  place: number
}

/**
 * This component is a modal acting as the parent of the language selector
 */
const LanguageModal: React.FC<LanguageModalProps> = ({ onClose, place }) => {
  const { t } = useCustomTranslation()
  const [language, setLanguage] = useState<AppLang>(getCurrentLanguage())
  const { changeUserLanguage, invalidateUserLanguage } = useUserLanguage()

  const modalActions = {
    primary: {
      name: t('common.save'),
      onClick: () => {
        changeUserLanguage(
          { language },
          {
            onSuccess: () => {
              changeAppLanguage(language)
              invalidateUserLanguage()
              onClose()
            },
          }
        )
      },
    },
    secondary: { name: t('common.cancel') },
  }

  return (
    <Dialog title={t('common.language')} onClose={onClose} actions={modalActions} maxWidth="sm">
      <LanguageSelector language={language} setLanguage={setLanguage} />
    </Dialog>
  )
}

export default LanguageModal
